<div class=" banner_header">
    <div class="col-md-12">
        <h2>Download</h2>
    </div>
</div>

<div class="container">
    <div class="row download_section">
        <div class="col-md-12">
            <h2>How to Install and Configure Safe Exam Bowser</h2>
        </div>
    </div>

        <div class="row">
            <div class="col-md-12 step_cls">
               <span class="steps"> 1 </span>
               <p>  To download Safe Exam Browser  <a target="_blank" href="https://safeexambrowser.org/download_en.html" class="click_here"> Click Here </a> </p>
               <!-- <p> Download Safe Exam Browser To download Safe Exam Browser  <a target="_blank" href="https://safeexambrowser.org/download_en.html" class="click_here"> Click Here </a> </p> -->
                <p> User Manual for Safe Exam Browser Installation  <a target="_blank" href="https://www.nimionlinetesting.in/aitt_exam/pdf/how%20to%20download%20and%20install%20SEB1.pdf" class="click_here"> Click Here </a> </p>

            </div>
            <div class="col-md-12 step_cls">
                <span class="steps"> 2 </span>
                <p>  To download Configuration File for Exam <a href="assets/images/SebClientSettingsnewforsession.seb" class="click_here"> Click Here </a>  </p>
                <!-- <p> Download Configuration File for Exam To download Configuration File  <a href="assets/images/SebClientSettingsnewforsession.seb" class="click_here"> Click Here </a>  </p> -->
                 <p> User Manual to Start Exam in Safe Exam Browser  <a target="_blank" href="https://www.nimionlinetesting.in/aitt_exam/pdf/how%20to%20download%20and%20open%20configuration%20file.pdf" class="click_here"> Click Here </a> </p>

             </div>
         </div>


         <div class="row download_section ">
            <div class="col-md-12">
                <h2>General guidelines to candidates for AITT - CBT</h2>
            </div>
        </div>

            <div class="row dwn_btm">
                <div class="col-md-12 step_cls">
                   <span class="steps"> 1 </span>
                   <p> General guidelines for candidates -   <a target="_blank" href="https://www.nimionlinetesting.in/aitt_exam/pdf/GeneralguidelinestoCandidates.pdf" class="click_here"> Click Here </a> </p>
                   <p>Instructions SEB Hindi <a target="_blank" href="https://www.nimionlinetesting.in/aitt_exam/pdf/Imp.%20Instructions%20SEB%20Hindi.pdf" class="click_here"> Click Here </a></p>
                </div>
                <div class="col-md-12 step_cls">
                    <span class="steps"> 2 </span>
                    <p> User Manual for candidates to take up AITT - CBT  <a target="_blank" href="https://www.nimionlinetesting.in/aitt_exam/pdf/UserManualAITT-CBTOnline%20Exam.pdf" class="click_here"> Click Here </a>  </p>
                 </div>
             </div>


    </div>




<style>
    .banner_header{
        background: #2955a9;
    padding: 10px 0px;
    text-align: left;
    color: #fff;
    margin: 0px;
    }
    .banner_header h2{
        font-size: 21px;
    }
    .download_section{
        padding: 40px 0px;
        text-align: center;
    }
    .dwn_btm{
        padding-bottom: 60px;
    }
    .steps{
        left: 0px;
    height: 40px;
    width: 40px;
    background-color: #29ab55;
    border-radius: 50%;
    display: inline-block;
    font-size: 24px;
    text-align: center;
    color: #fff;
    position: absolute;
    }
    .step_cls{
        padding: 0px 70px 30px;
    }
    .click_here{
        background: #2955a9;
    padding: 5px 15px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    border-radius: 10px;
    width: fit-content;
    cursor: pointer;
    }
    .click_here:hover{
        background-color: #000;
        text-decoration: none;
    }
    @media only screen and (max-width: 767px)  {
       h2{
      font-size: 24px;
      text-align: center;
    }
    .steps{
        left: 20px
    }
    .click_here{
        display: block;
    }
    }

</style>
